import { render } from "./ApiTransactionListComponent.vue?vue&type=template&id=ddab9e6e&scoped=true"
import script from "./ApiTransactionListComponent.vue?vue&type=script&lang=js"
export * from "./ApiTransactionListComponent.vue?vue&type=script&lang=js"

import "./ApiTransactionListComponent.vue?vue&type=style&index=0&id=ddab9e6e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ddab9e6e"]])

export default __exports__